import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=c85998ce&scoped=true"
import script from "./global-search.vue?vue&type=script&lang=ts"
export * from "./global-search.vue?vue&type=script&lang=ts"
import style0 from "./global-search.vue?vue&type=style&index=0&id=c85998ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85998ce",
  null
  
)

export default component.exports